import React from "react";
import InterviewPreparation from "../../../components/InterviewPreparation/InterviewPreparation";

function InterviewPreparationPage() {
  return <InterviewPreparation />;
}

export default InterviewPreparationPage;
